import { IAbcComponent } from '../abcComponent.model';
export interface IContextMenu extends IAbcComponent {
  style: contextMenuStyle;
}

export class AbcContextMenu<T = {}> {
  id?: string | number;
  caption?: string;
  disabled?: boolean;
  text?: string;
  image?: string;
  icon?: string;
  target?: string;
  name?: string;
  width?: string | number;
  height?: string | number;
  data?: any;
  visible?: boolean;
  items?: AbcContextMenu<T>[];
  onItemClick?: any;
  submenuDirection?: SubmenuDirection;
  closeOnOutsideClick?: boolean;
  hoverStateEnabled?: boolean;
  rtlEnabled?: boolean;
}

export enum contextMenuStyle {
  Round = 'Round',
  Normal = 'Normal',
}
export enum SubmenuDirection {
  Auto = 'auto',
  Left = 'left',
  Right = 'right',
}
